export { default as NUpload, uploadProps } from './src/Upload';
export { default as NUploadDragger } from './src/UploadDragger';
export { default as NUploadTrigger } from './src/UploadTrigger';
export { default as NUploadFileList } from './src/UploadFileList';
